import { types } from "mobx-state-tree";

import { RequiredValidatorModel } from "../required/RequiredValidator";
import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";
import { NumberValidatorModel } from "./NumberValidator";

const IntegerNumberProperties = types.model({
  format: "",
});

export const RequiredIntegerProperties = types.model({
  length: types.maybeNull(types.number),
  maxValue: types.maybeNull(types.number),
  isRequired: types.boolean,
  requiredValidator: types.optional(RequiredValidatorModel, {}),
});

export const IntegerNumberValidatorModel = types
  .compose(ValidatorModel, NumberValidatorModel, IntegerNumberProperties, RequiredIntegerProperties)
  .actions((self) => {
    const integerNumberTooLongMessage = (length: number) => {
      const maximumNumberValue = Math.pow(10, length) - 1;
      return ValidationMesssageModel.create({
        message: { mainKey: "general.validation.number-length-long" },
        context: { maximumNumberValue },
      });
    };

    const validateIntegerNumberByProperties = (fieldValueAsString: string) => {
      const [integerPart = ""] = fieldValueAsString.split(/[,.]/);

      if (fieldValueAsString !== integerPart)
        return ValidationMesssageModel.create({
          message: { mainKey: "general.validation.number-without-decimals" },
        });

      if (self.maxValue && self.numberTooLarge(self.maxValue, fieldValueAsString)) {
        return self.numberTooLargeMessage(self.maxValue)
      }

      if (self.length && self.numberTooLong(self.length, integerPart)) {
        return integerNumberTooLongMessage(self.length);
      }
    };

    return {
      validate(value: any) {
        if (self.isRequired) {
          const result = self.requiredValidator.validate(value);
          if (result && result.message.mainKey) return result;
        }

        const fieldValueAsString: string | undefined = value ? String(value).trim() : undefined;

        if (!fieldValueAsString) return undefined;

        if (!self.isANumber(fieldValueAsString) || fieldValueAsString === "")
          return ValidationMesssageModel.create({
            message: { mainKey: "general.validation.number" },
          });

        if (!self.length) return undefined;

        return validateIntegerNumberByProperties(fieldValueAsString);
      },
    };
  });
